import { Identifiable, Project, ProjectExternalLink } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function extractList(data: { [key: string]: string }): ProjectExternalLink[] {
  return Object.entries<ProjectExternalLink>(
    JSON.parse(data.externalLinks || "{}"),
  ).map(([index, link]) => ({ ...link, index: parseInt(index) }));
}

function getProjectExternalLinks(httpClient: HttpClient) {
  return (project: Identifiable<Project>) =>
    httpClient
      .sendHttpRequest<Identifiable<Project>>({
        endpoint: `/projects/${project.uuid}`,
        method: HttpMethods.GET,
      })
      .then(({ data }) => extractList(data));
}

export { getProjectExternalLinks };
